module.exports = __webpack_public_path__ + "static/media/at_rest_small.f3aef21c.jpg";